import { render, staticRenderFns } from "./Tipos.vue?vue&type=template&id=67173aa6&scoped=true&"
import script from "./Tipos.vue?vue&type=script&lang=js&"
export * from "./Tipos.vue?vue&type=script&lang=js&"
import style0 from "./Tipos.vue?vue&type=style&index=0&id=67173aa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67173aa6",
  null
  
)

export default component.exports